import { useSelector } from "react-redux";

const useUsermanagement = () => {
  const userManagement = useSelector((state) => state.userManagement);
  const { adminGroupUsersData } = userManagement.adminGroupUsers;
  const { addAdminGroupUserData } = userManagement.addAdminGroupUser;
  const { allUsersData } = userManagement.allUsers;
  const { usersHistoryData } = userManagement.usersHistory;
  const { editUserData } = userManagement.editUser;
  const { deleteUserData } = userManagement.deleteUser;
  const { addUserData } = userManagement.addUser;
  const { deleteAdminGroupUserData } = userManagement.deleteAdminGroupUser;
  const { usersRolesData } = userManagement.usersRoles;
  const { plannedOutageUsersData } = userManagement.plannedOutageUsers;
  const { addPlannedOutageUserData } = userManagement.addPlannedOutageUser;
  const { deletePlannedOutageUserData } = userManagement.deletePlannedOutageUser;
  return {
    adminGroupUsersData,
    addAdminGroupUserData,
    allUsersData,
    usersHistoryData,
    editUserData,
    deleteUserData,
    addUserData,
    deleteAdminGroupUserData,
    usersRolesData,
    plannedOutageUsersData,
    addPlannedOutageUserData,
    deletePlannedOutageUserData
  };
};
export default useUsermanagement;
